import {
  Button,
  Card,
  Grid,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import React, { useEffect, useState } from 'react';

const RobotReactionInputForm = (props) => {
  const { onSave, value: v, init } = props;
  const [value, setValue] = useState(v || 0);
  const handleSaveClick = () => value > -1 && onSave && onSave(value);
  const handleChange = (e) => {
    setValue(Number(e.target.value));
  };

  useEffect(() => setValue(v), [v, init]);

  return (
    <Card>
      <CardContent>
        <Grid container>
          <Grid
            item
            xs={12}
            display="inline-flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" component="h6">
              성향 설정
            </Typography>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleSaveClick}
            >
              저장
            </Button>
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset" sx={{ margin: 1 }}>
              <RadioGroup
                aria-label="reaction"
                name="controlled-radio-buttons-group"
                defaultValue={v}
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio color="secondary" />}
                  label="소극적"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio color="secondary" />}
                  label="적극적"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} display="inline-flex" alignItems="center">
            <InfoIcon color="secondary" sx={{ mr: 1 }} />
            <Typography variant="body2">
              성향 설정에 따라 해당 로봇의 활성도 및 반응이 증가(적극적) 또는
              감소(소극적)합니다.
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RobotReactionInputForm;
